export enum EProjectDiscussionStatus {
  DRAFT_COMMENT = 'DC',
  COMMENTED = 'C',
  DRAFT_RESPONSE = 'DR',
  RESPONSED = 'R',
}

export enum EProjectDiscussionFormType {
  DESIGN_BRIEF = 'DesignBrief',
  DESIGN_MODIFICATION_ICE = 'DesignModificationIce',
  DESIGN_MODIFICATION = 'DesignModification',
  DESIGN_MODIFICATION_REV = 'DesignModificationRev',
  LOADING_REMOVAL_CERT = 'LoadingRemovalCert',
  TRANSMITTAL = 'Transmittal',
  LAMBETH_REVIEWER_RESPONSE = 'LambethReviewerResponse',
}
